import { useState } from 'react';

const initialFormState = {
  companyName: '',
  country: 'Россия',
  address: '',
  phoneNumber: '+7',
  email: '',
  inn: '',
  ogrn: '',
  region: '',
  city: '',
  street: '',
  house: '',
};

export function useAddBuyerFormState() {
  const [formState, setFormState] = useState(initialFormState);

  const handleChange = (
    fieldName: string,
    value: number | string,
    type: 'string' | 'number' = 'string',
    max: number | null = null
  ) => {
    setFormState({
      ...formState,
      [fieldName]:
        type === 'number'
          ? (max !== null && +String(value).replace(/\D/g, '') > max ? max : String(value).replace(/\D/g, '') || '')
          : value,
    });
  };

  const resetForm = () => {
    setFormState(initialFormState);
  };

  return {
    formState,
    handleChange,
    resetForm,
    setFormState,
  };
}